import React from 'react';
import { Box, Typography, Link } from '@mui/material';

export const Answer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>{children}</Box>
);

export const AnswerLead: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography sx={{
    color: 'var(--Text-primary, #000)',
    fontFamily: '"Repro", sans-serif',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '150%'
  }}>
    {children}
  </Typography>
);

export const AnswerP: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography sx={{
    color: 'var(--Text-primary, #000)',
    fontFamily: '"Repro", sans-serif',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%'
  }}>
    {children}
  </Typography>
);

export const AnswerList: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box component="ul" sx={{ pl: '18px', m: 0, '& > li + li': { mt: '8px' } }}>{children}</Box>
);

export const AnswerLi: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box component="li" sx={{
    color: 'var(--Text-primary, #000)',
    fontFamily: '"Repro", sans-serif',
    fontSize: 16,
    lineHeight: '150%'
  }}>
    {children}
  </Box>
);

export const AnswerLink: React.FC<{ href: string; children: React.ReactNode }> = ({ href, children }) => (
  <Link href={href} underline="always" sx={{ color: 'var(--Primary-Blue, #355ADD)', fontWeight: 400 }}>
    {children}
  </Link>
);


